import { render } from "./WorkAreaDetailsPageSettings.vue?vue&type=template&id=673c7637"
import script from "./WorkAreaDetailsPageSettings.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetailsPageSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script